import { PartnerTypes } from '@cointracker/shared-utils';
import { COOKIE_KEYS, URLS, setCookie } from '@cointracker/ui';
import { CBO_PROMO_KEY } from '../CoinbaseOnePromotionPage/CoinbaseOnePromotionPage/constants';
import type { Partner } from './partnerStore';

export const METAMASK_ACCOUNTS_KEY = 'add-wallet-form-multiple-wallets';
export const REFERRAL_TTL_DAYS = 1;

export const getNextUrl = (
  searchParams: URLSearchParams,
  partner?: Partner | null,
): string | undefined => {
  if (searchParams.get('next') === 'view_client_invites') {
    return `${URLS.VIEW_TAX_PRO_CLIENTS}?showInvites=true`;
  }
  // If on a partner page, pass any query params to the SPA
  if (partner) {
    return `${URLS.HOME_PAGE}${window.location.search}`;
  }
};

export const setCookies = (parter: Partner, utmSource?: string) => {
  setCookie(COOKIE_KEYS.partnerSlug, parter.slug, REFERRAL_TTL_DAYS);
  if (parter.userId) {
    setCookie(COOKIE_KEYS.partnerUserId, parter.userId, REFERRAL_TTL_DAYS);
  }
  if (utmSource) {
    setCookie(COOKIE_KEYS.utmSource, utmSource, REFERRAL_TTL_DAYS);
  }
};

export const processPartnerSpecificURLParams = (
  partner: string,
  searchParams: URLSearchParams,
) => {
  switch (partner) {
    case 'metamask': {
      const accountsParam = searchParams.get('accounts');
      if (accountsParam) {
        const parsedAccounts = accountsParam.split(',');
        const formattedAccounts = parsedAccounts
          .map((account) => `ETH:${account}`)
          .join(', ');
        localStorage.setItem(METAMASK_ACCOUNTS_KEY, formattedAccounts);
      }
      break;
    }
    case 'coinbaseone': {
      if (searchParams.has('c')) {
        localStorage.setItem(CBO_PROMO_KEY, searchParams.get('c') as string);
      }
      break;
    }
    default:
      break;
  }
};

export const buildGetStartedUrl = (nextUrl?: string): string => {
  if (!nextUrl) return URLS.GET_STARTED_PAGE;

  return `${URLS.GET_STARTED_PAGE}?next=${encodeURIComponent(nextUrl)}`;
};

export function determineDiscountText({
  partnerDiscountText,
  invalidAfterDate,
  earlyBirdDiscount,
}: {
  partnerDiscountText?: string;
  invalidAfterDate?: string;
  earlyBirdDiscount?: boolean;
}): string | undefined {
  const today = new Date();
  const pstToday = new Date(
    today.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }),
  );
  if (pstToday.getFullYear() >= 2026) return undefined;
  if (invalidAfterDate) {
    const invalidAfter = new Date(invalidAfterDate);
    if (pstToday > invalidAfter) {
      return undefined;
    }
  }
  const earlyBirdDiscountTextActive =
    earlyBirdDiscount && pstToday.getMonth() < 1; // January

  return earlyBirdDiscountTextActive
    ? 'Early bird sale - new users get 20% off all plans until Jan 31'
    : partnerDiscountText;
}

export const getPartner = (partnerSlug: string): Partner | null => {
  for (const partner of Object.values(PartnerTypes)) {
    if (partner.slug === partnerSlug) {
      return partner;
    }
  }
  return null;
};
